import React, { useMemo, useState } from 'react';
import { OrganizationQuery, RoleQuery } from 'queries';
import { RoleScope } from 'types';

const selectCss = {
  width: '100%',
  padding: '8px 12px',
  border: '1px solid #ddd',
  borderRadius: 4,
};

interface Props {
  roleId: string;
  onChange: (roleId: string) => void;
}

// 조직 → 역할 2단 선택
function RoleSelect({ roleId, onChange }: Props) {
  const { data: orgs = [] } = OrganizationQuery.useGetAll();
  const [scopeValue, setScopeValue] = useState('');
  const scope: RoleScope | null = scopeValue === '' ? null : Number(scopeValue);
  const { data: roles = [] } = RoleQuery.useGetAll(scope ?? 0, scope !== null);
  const scopeRoles = useMemo(
    () => (scope === null ? [] : roles.filter((r) => !r.disabled)),
    [scope, roles],
  );

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <select
        value={scopeValue}
        onChange={(e) => {
          setScopeValue(e.target.value);
          onChange('');
        }}
        css={selectCss}
      >
        <option value="">조직 선택</option>
        {orgs.map((o) => (
          <option key={o.id} value={o.id}>
            {o.displayName}
          </option>
        ))}
      </select>
      <select
        value={roleId}
        onChange={(e) => onChange(e.target.value)}
        disabled={scope === null}
        css={selectCss}
      >
        <option value="">권한 선택</option>
        {scopeRoles.map((r) => (
          <option key={r.id} value={r.id}>
            {r.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default RoleSelect;
